import React from 'react';
import RulesConfirmModal from './RulesConfirmModal';

const DeleteConfirmModal = ({ visible, onConfirm, onCancel }) => {
  return (
    <RulesConfirmModal
      visible={visible}
      title="Delete Rule"
      message="Delete this rule? Orders will no longer be processed by it."
      confirmText="Delete"
      cancelText="Cancel"
      showUndoneWarning
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DeleteConfirmModal;
